import { IRuleTrigger } from "store/entities/rules/interfaces";

export enum WorkflowActionType {
  Assign = "assign",
  FeedbackRequest = "feedback-request",
  FollowUp = "follow-up",
  Message = "message",
  Status = "status",
  Priority = "priority",
  AddTag = "add-tag",
  RemoveTag = "remove-tag",
  Spam = "spam",
  Unspam = "unspam",
  AddFollowers = "add-followers",
  RemoveFollowers = "remove-followers",
  PrivateNote = "private-note",
}

export enum WorkflowPartGridType {
  Standard = "standard",
  WithCollection = "with-collection",
  WithCollectionThree = "with-collection-three",
  WithCollectionFour = "with-collection-four",
  Message = "message",
}

export enum WorkflowConditionType {
  TicketCreated = "ticket-created",
  TicketChanged = "ticket-changed",
  Source = "source",
  Status = "status",
  StatusChanged = "status-changed",
  Subject = "subject",
  NewRequesterMessage = "new-requester-message",
  NewAnyAgentMessage = "new-any-agent-message",
  NewPrivateAgentMessage = "new-private-agent-message",
  NewPublicAgentMessage = "new-public-agent-message",
  EventCount = "event-count",
  Team = "team",
  Agent = "agent",
  HasAssignee = "has-assignee",
  Requester = "requester",
  Tag = "tag",
  TagAdded = "tag-added",
  TagRemoved = "tag-removed",
  IsSpam = "is-spam",
  IsNotSpam = "is-not-spam",
  Priority = "priority",
  PriorityChanged = "priority-changed",
  Mailbox = "mailbox",
  Time = "time",
  TeamChanged = "team-changed",
  AgentChanged = "agent-changed",
  Follower = "follower",
  FollowerAdded = "follower-added",
  FollowerRemoved = "follower-removed",
  Rating = "rating",
  RatingChanged = "rating-changed",
  Language = "language",
}

export type TriggerFieldArrayElement = IRuleTrigger | Record<string, never>;

export type OpenedAccordionIndex = {
  type: "trigger" | "action";
  index: number;
} | null;
